import { Checkbox, FormControlLabel, Link, Typography } from "@mui/material";

const TermsAgreementField = ({
  values,
  touched,
  errors,
  handleBlur,
  setFieldValue,
  previewUrl,
}) => (
  <>
    <FormControlLabel
      control={
        <Checkbox
          name="terms_agreed"
          checked={values.terms_agreed}
          disabled={!previewUrl}
          onBlur={handleBlur}
          onChange={(event) => setFieldValue("terms_agreed", event.target.checked)}
        />
      }
      label={
        <Typography component="span" variant="body2">
          I agree to the{" "}
          <Link
            href={previewUrl || undefined}
            target="_blank"
            rel="noopener noreferrer"
            underline={previewUrl ? "always" : "none"}
            onClick={(event) => {
              if (!previewUrl) {
                event.preventDefault();
                return;
              }
              event.stopPropagation();
            }}
            sx={{
              color: previewUrl ? "#FCB200" : "inherit",
              fontWeight: previewUrl ? 600 : 400,
              pointerEvents: previewUrl ? "auto" : "none",
            }}
          >
            Terms and Conditions
          </Link>
        </Typography>
      }
    />
    {touched.terms_agreed && errors.terms_agreed && (
      <Typography variant="caption" color="error" sx={{ display: "block", ml: 1.75 }}>
        {errors.terms_agreed}
      </Typography>
    )}
    {touched.agreement_template_id && errors.agreement_template_id && (
      <Typography variant="caption" color="error" sx={{ display: "block", ml: 1.75 }}>
        {errors.agreement_template_id}
      </Typography>
    )}
  </>
);

export default TermsAgreementField;
